import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SessionModeEnum } from '@zaoblako/shared/modules/security/enums/session-mode.enum';
import { TypeFormEnum } from '@zaoblako/web/shared/components/form-sidebar/enums/type.form.enum';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  public currentUrl = '/';
  public previousUrl = '/';

  public constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly formStoreService: FormStoreService
  ) {}

  public subscribeRoutes() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd && event.url !== '/notfound'))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (this.route.snapshot.queryParams?.formType && this.route.snapshot.queryParams?.formId) {
          const formData = {
            formType: this.route.snapshot.queryParams?.formType,
            formId: this.route.snapshot.queryParams?.formId,
            formHeaderText: this.route.snapshot.queryParams?.formHeaderText,
            formWidthSize: this.route.snapshot.queryParams?.formWidthSize,
            formIsShowDelete: this.route.snapshot.queryParams?.formIsShowDelete,
            formIsShowShare: this.route.snapshot.queryParams?.formIsShowShare,
            formTypeZIndex: this.route.snapshot.queryParams?.formTypeZIndex
          };
          setTimeout(() => {
            this.formStoreService.editForm(
              formData.formType as TypeFormEnum,
              isNaN(+formData.formId) ? formData.formId : +formData.formId,
              {
                headerText: formData.formHeaderText,
                widthSize: formData.formWidthSize,
                isNotShowDelete: formData.formIsShowDelete?.toLowerCase() !== 'true',
                isShowShare: formData.formIsShowShare?.toLowerCase() === 'true',
                typeZIndex: formData.formTypeZIndex
              }
            );
          }, 4000);

          this.router
            .navigate([], {
              queryParams: {
                formType: null,
                formId: null,
                formHeaderText: null,
                formWidthSize: null,
                formIsShowDelete: null,
                formIsShowShare: null,
                formTypeZIndex: null
              },
              queryParamsHandling: 'merge'
            })
            .catch(console.error);
        }
      });
  }

  public goToPreviousUrl(sessionMode: SessionModeEnum) {
    if (sessionMode === SessionModeEnum.PERSONAL_ACCOUNT) {
      this.router.navigateByUrl('/lk/external-user').catch(console.error);
      return;
    }

    if (this.previousUrl !== '/register') {
      this.router.navigateByUrl(this.previousUrl).catch(console.error);
      return;
    }

    this.router.navigate(['']).catch(console.error);
  }

  public redirectToNotFound() {
    this.router.navigate(['notfound']).catch(console.error);
  }
}
